import { updateProducerQuoteFeederOptions } from "../../../../../service/producerServices";
import { updateQuoteFeedersTable } from "../../../../../service/sourceServices";
import { ProcessedQuoteFeed } from "../../../store/types";

interface UpdateAvailableQuoteFeedersTableArgs {
  quoteFeeds: ProcessedQuoteFeed[];
}

async function updateAvailableQuoteFeedersTable({ quoteFeeds }: UpdateAvailableQuoteFeedersTableArgs) {
  await Excel.run(async (context) => {
    const _a = await updateQuoteFeedersTable({ context, quoteFeeds });
    await context.sync();
    const _b = await updateProducerQuoteFeederOptions(context);
    await context.sync();
  });
}

export default updateAvailableQuoteFeedersTable;
